module.exports = __webpack_public_path__ + "56f70ed27c0beee950798d925c50fdb5.svg";